import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import ScheduleBoxRow from './Row'
import css from './styles.css'

const ScheduleBox = ({
  appointments,
  forReviews,
  requestReview,
  pmsType,
}) => (
  <div className={css.wrapper}>
    <ul className={css.header}>
      <li className={css.headerRow}>
        <div className={cx(css.headerCell, css.date)}>Date</div>
        <div className={cx(css.headerCell, css.time)}>Time</div>
        <div className={cx(css.headerCell, css.patient)}>Patient</div>
        {pmsType !== 'OrthoTrac' && <div className={cx(css.headerCell, css.doctor)}>Doctor</div>}
        {forReviews && <div className={cx(css.headerCell, css.location)}>Location</div>}
        {forReviews && <div className={cx(css.headerCell, css.rating)}>Rating</div>}
        {!forReviews && <div className={cx(css.headerCell, css.status)}>Status</div>}
        {!forReviews && (
          <div
            className={cx(css.headerCell, css.confirmed, [!!requestReview && css.adjusted])}
          >
            Confirmed
          </div>
        )}
        {!forReviews && !!requestReview && (
          <div className={cx(css.headerCell, css.requestReview)}>Request Review</div>
        )}
      </li>
    </ul>
    <ul className={css.body}>
      {appointments
        .filter(appointment => appointment.status !== 'Recall')
        .map((appointment) => {
          const { patient, doctor, location, review } = appointment
          return (
            <ScheduleBoxRow
              key={appointment.id}
              appointment={appointment}
              patient={patient}
              doctor={doctor}
              location={location}
              review={review}
              requestReview={requestReview}
              pmsType={pmsType}
            />
          )
        })}
    </ul>
  </div>
)

ScheduleBox.propTypes = {
  appointments: PropTypes.array.isRequired,
  forReviews: PropTypes.bool,
  requestReview: PropTypes.func,
  pmsType: PropTypes.string,
}

export default ScheduleBox



// WEBPACK FOOTER //
// ./src/components/sitewide/ScheduleBox/index.js